/**
 * Global Admin Styles
 * Common styles and configurations for all admin screens
 */

export const adminStyles = {
  // Loading spinner styles
  loadingSpinner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
    width: '100%',
  },

  // Container styles
  container: {
    p: 2.5,
    background: '#ffffff',
    minHeight: '100vh',
  },

  // Dialog title styles
  dialogTitle: {
    pr: 8,
    fontWeight: 'bold',
    color: 'primary.main',
  },

  // Paper/Card styles
  paper: {
    elevation: 0,
    p: 2,
    borderRadius: 1,
    background: '#ffffff',
    border: '1px solid #e0e0e0',
  },

  // Statistics box styles
  statsBox: {
    display: 'flex',
    gap: 2,
    p: 1.5,
    background: '#f8f9fa',
    borderRadius: 1,
    border: '1px solid #e9ecef',
  },

  // Tab styles
  tabs: {
    borderBottom: '1px solid #e0e0e0',
    '& .MuiTab-root': {
      textTransform: 'none',
      fontWeight: 600,
      minHeight: 48,
    },
  },

  // Button styles
  button: {
    textTransform: 'none',
    fontWeight: 600,
  },

  // Grid container styles
  gridContainer: {
    spacing: 2,
  },

  // Skeleton animation
  skeleton: {
    animation: 'pulse 1.5s ease-in-out infinite',
  },
};

// Loading spinner component configuration
export const loadingConfig = {
  size: 40,
  thickness: 4,
  color: 'primary',
};

// Skeleton configuration
export const skeletonConfig = {
  animation: 'wave',
  variant: 'rectangular',
};

